<div class="container">
  <h4 class="head-text mb-4">
    <strong>You need to complete your account registration by providing the detail below:</strong>
  </h4>

  <form class="corporate-form" [formGroup]="coporateForm">
    <div class="row">
      <div class="col-12 col-md-8 col-lg-6 mx-auto">
        <p>
          <strong>Your Date of Birth</strong>
        </p>
        <div class="form-group">
          <div class="row">
            <div class="col-3 pr-0">
              <mat-form-field [ngClass]="{
                    'is-invalid': (!validateDOB || notValidateAge) && !ipDay.isFocus && !ipMonth.isFocus && !ipYear.isFocus && coporateForm.get('day').touched && coporateForm.get('month').touched && coporateForm.get('year').touched,
                    'is-valid': validateDOB && !notValidateAge && !ipDay.isFocus && !ipMonth.isFocus && !ipYear.isFocus}">
                <input matInput placeholder="Day" (blur)="checkValidateDOB('day')" onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                  formControlName="day" npDetectFocus #ipDay="detectFocus" maxlength="2">
              </mat-form-field>
            </div>
            <div class="col-3 pr-0">
              <mat-form-field [ngClass]="{
                    'is-invalid': (!validateDOB || notValidateAge) && !ipDay.isFocus && !ipMonth.isFocus && !ipYear.isFocus && coporateForm.get('day').touched && coporateForm.get('month').touched && coporateForm.get('year').touched,
                    'is-valid': validateDOB && !notValidateAge && !ipDay.isFocus && !ipMonth.isFocus && !ipYear.isFocus}">
                <input matInput placeholder="Month" (blur)="checkValidateDOB('month')" onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                  formControlName="month" npDetectFocus #ipMonth="detectFocus" maxlength="2">
              </mat-form-field>
            </div>
            <div class="col-6">
              <mat-form-field [ngClass]="{
                    'is-invalid': (!validateDOB || notValidateAge) && !ipDay.isFocus && !ipMonth.isFocus && !ipYear.isFocus && coporateForm.get('day').touched && coporateForm.get('month').touched && coporateForm.get('year').touched,
                    'is-valid': validateDOB && !notValidateAge && !ipDay.isFocus && !ipMonth.isFocus && !ipYear.isFocus}">
                <input matInput placeholder="Year" (blur)="checkValidateDOB('year')" onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                  formControlName="year" npDetectFocus #ipYear="detectFocus" maxlength="4">
              </mat-form-field>
            </div>
          </div>

          <div *ngIf="!validateDOB && !ipDay.isFocus && !ipMonth.isFocus && !ipYear.isFocus && coporateForm.get('day').touched && coporateForm.get('month').touched && coporateForm.get('year').touched">
            <p class="err-message">Please enter a valid date</p>
          </div>
          <div *ngIf="validateDOB && notValidateAge && !ipDay.isFocus && !ipMonth.isFocus && !ipYear.isFocus && coporateForm.get('day').touched && coporateForm.get('month').touched && coporateForm.get('year').touched">
            <p class="err-message">Client must be 16 and over!</p>
          </div>
        </div>

        <div class="form-group">
          <mat-form-field [ngClass]="{
              'is-invalid': postCodeCtrl.hasError('required') && postCodeCtrl.touched,
              'is-valid': postCodeCtrl.valid && postCodeCtrl.touched
            }">
            <input matInput formControlName="postCode" type="text" npDetectFocus #ipPC="detectFocus" placeholder="Post code" />
          </mat-form-field>
          <div *ngIf="postCodeCtrl.hasError('required') && postCodeCtrl.touched && !ipPC.isFocus">
            <p class="err-message">Please input valid information here</p>
          </div>
          <div *ngIf="postCodeCtrl.hasError('pattern') && postCodeCtrl.touched && !ipPC.isFocus" class="error-message">
            {{ commonMessage.messageForSafeCharactersField }}
          </div>
        </div>
        <div class="form-group pb-4">
          <div class="row">
            <div class="col-12 col-lg-4 pr-md-0 mb-3">
              <button type="button" class="btn btn-block btn-lg btn-greengo" (click)="searchPostCode()" [disabled]="!this.postCodeCtrl.value" npFocusOutClicked>
                Search
              </button>
            </div>
            <div class="col-12 col-lg-8">
              <button type="button" class="btn btn-block btn-lg btn-greengo" (click)="enterManually()">
                Manually enter address
              </button>
            </div>
          </div>
        </div>
        <ng-container *ngIf="showAddressList">
          <div class="form-group">
            <mat-form-field>
              <input matInput formControlName="address" type="text" placeholder="Address result" />
            </mat-form-field>
          </div>

          <div class="address-result">
            <ul class="address-result-ul" *ngIf="defaultAddress.length > 0 && addressResults.length > 0">
              <li class="address-select-li" *ngFor="let addressResult of addressResults" (click)="chooseAddress(addressResult)" value="addressResult">
                {{ addressResult.text }}
                <br />
                <span class="description">{{ addressResult.description }}</span>
              </li>
            </ul>
            <ul class="address-result-ul" *ngIf="defaultAddress.length > 0 && addressResults.length === 0">
              <li class="address-select-li no-result">
                <span class="description">No result found</span>
              </li>
            </ul>
          </div>
        </ng-container>

        <ng-container *ngIf="showAddressDetail">
          <div class="form-group">
            <mat-form-field [ngClass]="{
              'is-invalid': flatnoCtrl.hasError('required') && flatnoCtrl.touched,
              'is-valid': flatnoCtrl.valid && flatnoCtrl.touched
            }">
              <input matInput formControlName="flatno" type="text" npDetectFocus #ipflat="detectFocus" placeholder="Flat Number" />
            </mat-form-field>
            <div *ngIf="flatnoCtrl.hasError('required') && flatnoCtrl.touched && !ipflat.isFocus" class="error-message">
              Please input valid information here
            </div>
            <div *ngIf="flatnoCtrl.hasError('pattern') && flatnoCtrl.touched && !ipflat.isFocus" class="error-message">
              {{ commonMessage.messageForSafeCharactersField }}
            </div>
          </div>

          <div class="form-group">
            <mat-form-field [ngClass]="{
              'is-invalid': accountType === 'client' && (!buildingnameCtrl.value && !buildingnumCtrl.value) && buildingnameCtrl.touched && buildingnumCtrl.touched && !ipbuildingnum.isFocus && !ipbuildingname.isFocus,
              'is-valid':  ((accountType === 'client' && (buildingnameCtrl.value || buildingnumCtrl.value)) || accountType !== 'client') && buildingnameCtrl.touched
            }">
              <input matInput formControlName="buildingname" type="text" npDetectFocus #ipbuildingname="detectFocus" placeholder="Building Name"
              />
            </mat-form-field>
            <div *ngIf="buildingnameCtrl.hasError('required') && buildingnameCtrl.touched && !ipbuildingname.isFocus" class="error-message">
              Please input valid information here
            </div>
            <div *ngIf="buildingnameCtrl.hasError('pattern') && buildingnameCtrl.touched && !ipbuildingname.isFocus" class="error-message">
              {{ commonMessage.messageForSafeCharactersField }}
            </div>
          </div>

          <div class="form-group">
            <mat-form-field [ngClass]="{
              'is-invalid': accountType === 'client' && (!buildingnameCtrl.value && !buildingnumCtrl.value) && buildingnameCtrl.touched && buildingnumCtrl.touched && !ipbuildingnum.isFocus && !ipbuildingname.isFocus,
              'is-valid': ((accountType === 'client' && (buildingnameCtrl.value || buildingnumCtrl.value)) || accountType !== 'client') && buildingnumCtrl.touched
            }">
              <input matInput formControlName="buildingnum" type="text" npDetectFocus #ipbuildingnum="detectFocus" placeholder="Building Number"
              />
            </mat-form-field>
            <div *ngIf="accountType === 'client' && !buildingnameCtrl.value && !buildingnumCtrl.value && buildingnameCtrl.touched && buildingnumCtrl.touched && !ipbuildingnum.isFocus && !ipbuildingname.isFocus">
              <p class="err-message">Please input Building Name or Building Number</p>
            </div>
            <div *ngIf="buildingnumCtrl.hasError('required') && buildingnumCtrl.touched && !ipbuildingnum.isFocus" class="error-message">
              Please input valid information here
            </div>
            <div *ngIf="buildingnumCtrl.hasError('pattern') && buildingnumCtrl.touched && !ipbuildingnum.isFocus" class="error-message">
              {{ commonMessage.messageForSafeCharactersField }}
            </div>
          </div>

          <div class="form-group">
            <mat-form-field [ngClass]="{
              'is-invalid': streetCtrl.hasError('required') && streetCtrl.touched,
              'is-valid': streetCtrl.valid && streetCtrl.touched
            }">
              <input matInput formControlName="street" type="text" npDetectFocus #ipstreet="detectFocus" placeholder="Street" />
            </mat-form-field>
            <div *ngIf="streetCtrl.hasError('required') && streetCtrl.touched && !ipstreet.isFocus" class="error-message">
              Please input valid information here
            </div>
            <div *ngIf="streetCtrl.hasError('pattern') && streetCtrl.touched && !ipstreet.isFocus" class="error-message">
              {{ commonMessage.messageForSafeCharactersField }}
            </div>
          </div>

          <div class="form-group">
            <mat-form-field [ngClass]="{
                'is-invalid': cityCtrl.hasError('required') && cityCtrl.touched,
                'is-valid': cityCtrl.valid && cityCtrl.touched
              }">
              <mat-label>City / Town</mat-label>
              <input matInput formControlName="city" type="text" npDetectFocus #ipcity="detectFocus" />
            </mat-form-field>
            <div *ngIf="cityCtrl.hasError('required') && cityCtrl.touched && !ipcity.isFocus" class="error-message">
              Please input valid information here
            </div>
            <div *ngIf="cityCtrl.hasError('pattern') && cityCtrl.touched && !ipcity.isFocus" class="error-message">
              {{ commonMessage.messageForSafeCharactersField }}
            </div>
          </div>

          <div class="form-group">
            <mat-form-field [ngClass]="{ 'is-valid': countyStateCtrl.valid && countyStateCtrl.touched }">
              <mat-label>County/ State</mat-label>
              <input matInput formControlName="countyState" type="text" npDetectFocus #ipCounty="detectFocus" />
            </mat-form-field>
            <div *ngIf="countyStateCtrl.hasError('required') && countyStateCtrl.touched && !ipCounty.isFocus" class="error-message">
              Please input valid information here
            </div>
            <div *ngIf="countyStateCtrl.hasError('pattern') && countyStateCtrl.touched && !ipCounty.isFocus" class="error-message">
              {{ commonMessage.messageForSafeCharactersField }}
            </div>
          </div>

          <div class="form-group">
            <mat-form-field [ngClass]="{
                'is-invalid': countryCtrl.hasError('required') && countryCtrl.touched,
                'is-valid': countryCtrl.valid && countryCtrl.touched
              }">
              <mat-label>Country</mat-label>
              <mat-select placeholder="Country" formControlName="country" npDetectFocus #ipCountry="detectFocus">
                <mat-option *ngFor="let country of countries" [value]="country">
                  {{ country.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <div *ngIf="countryCtrl.hasError('required') && countryCtrl.touched && !ipCountry.isFocus">
              <p class="err-message">Please input valid information here</p>
            </div>
          </div>
        </ng-container>

        <div class="row">
          <div class="col-12 pb-4">
            <button *ngIf="!completedOnfido" class="btn btn-block btn-lg" id="onfido-button" (click)="uploadOnfido()" [ngClass]="{
              'btn-greengo': coporateForm.valid && validateDOB && !notValidateAge,
              'btn-inactive': !coporateForm.valid || !validateDOB || notValidateAge
            }" npFocusOutClicked>
              Verify your identity now
            </button>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div id="onfido-mount" class="onfido-mount--wrapper"></div>
          </div>
        </div>
      </div>
    </div>

    <ng-container *ngIf="completedOnfido && !allowAutoAddressApproval">
      <div class="row">
        <div class="text-justify">
          <p>
            <strong>Proof of Address</strong>
          </p>
          <p>Security is front of mind at {{brandName}}, and protection is our promise. We always verify addresses via electronic
            sources when possible, but additional proof of identity is sometimes required. </p>
          <p>Accepted documentation includes
            <strong> a utility bill (not a mobile/cell account), bank or mortgage statement, a valid full driving licence, or a letter
              addressed to you from a local or national government body (such as your local council or HMRC). Please note,</strong>
            all documents must be in your name with your current address and dated within the last three months. </p>
          <p>For those customers in the UAE and other Gulf States we understand the difficulty in obtaining the usual proof
            of address, so we will accept your valid Residential Identity Card alongside a utility bill or rental agreement
            for the property in which you reside. </p>
          <br>
          <p>
            <strong>Source of Wealth</strong>
          </p>
          <p>As you’d expect from a fully authorised UK firm, we are occasionally required to ask about the funds that you deposit
            in your personal E-Wallet. This is only when absolutely necessary, but if you wish to avoid this entirely you
            can upload documents now which support your source of wealth (for example wage slips, evidence of savings, sale
            of property or inheritance). If you wish, you can also upload documents which explain the reason for a proposed
            transaction such a house purchase or relocation.</p>
          <p>We take your data security very seriously so we will never ask you to send us documents by email. In future, you
            can send documentation via your Relationship Manager using our simple but secure online tool.</p>
          <p>* Please note we can accept copies of documents in GIF, JPG, PNG, PDF, TIFF formats of up to 10MB per file. </p>
          <br>
        </div>

        <div class="col-12 col-md-8 col-lg-6 mx-auto">
          <ng-container *ngIf="!completedUploadingSupportingDocs">
            <div class="row form-group">
              <div class="col-12">
                <np-drop-zone #drop [id]="'idtest'" [aria-label]="'al-test'" [aria-labelledby]="'alb-test'" (change)="uploadFileChanged($event)"
                  [multiple]="false">
                  <np-drop-zone-label>
                    <p class="dnd-label">Drag and drop your files here or</p>
                    <p class="browse-label">browse files</p>
                  </np-drop-zone-label>
                  <ng-container *ngIf="targetFile">
                    <np-drop-zone-preview [removable]="true" (removed)="onRemove()">
                      <np-drop-zone-label>{{ targetFile.name }}
                        <span class="format-size">({{ targetFile.size | formatBytes }})</span>
                      </np-drop-zone-label>
                    </np-drop-zone-preview>
                  </ng-container>
                </np-drop-zone>
              </div>
            </div>
            <ng-container *ngIf="targetFile">
              <div class="row form-group">
                <div class="col-12">
                  <button class="btn btn-block btn-lg btn-greengo" (click)="saveSupportFile()" npFocusOutClicked>
                    Upload
                  </button>
                </div>
              </div>
            </ng-container>
          </ng-container>

          <ng-container *ngIf="filesUploaded.length > 0">
            <div class="row form-group">
              <div class="col-12">
                <div class="files-uploaded-info">
                  <p *ngIf="filesUploaded.length === 1">
                    <strong>File uploaded</strong>
                  </p>
                  <p *ngIf="filesUploaded.length > 1">
                    <strong>Files uploaded</strong>
                  </p>
                  <ol>
                    <li *ngFor="let fileUploaded of filesUploaded">
                      {{ fileUploaded.originalFileName }}
                    </li>
                  </ol>
                </div>
              </div>
            </div>
          </ng-container>

          <ng-container *ngIf="!targetFile && filesUploaded.length > 0 && !completedUploadingSupportingDocs">
            <div class="row form-group">
              <div class="col-12 pb-4">
                <button class="btn btn-block btn-lg btn-greengo" (click)="finishedUploadingClicked()">
                  Finish uploading
                </button>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="(allowAutoAddressApproval || completedUploadingSupportingDocs) && completedOnfido">
      <div class="row">
        <div class="col-12 col-md-6 offset-md-3">
          <div class="term-use mb-5">
            <p>By accepting, you are confirming on behalf of the Applicant:</p>
            <ol>
              <li>
                You hereby authorise {{brandNameUpperCase}} Limited and/or its associated companies to undertake all necessary checks and searches in relation
                to the Applicant and its authorised signatories to enable {{brandNameUpperCase}} Limited to make an assessment as to the
                Applicant’s suitability as a client.
              </li>
              <li>
                All information contained in the Application Form is true, accurate and not misleading and all statements of opinion contained
                in it are reasonably held.
              </li>
              <li>
                You have read and accept the
                <a *ngIf="accountType === 'client'" href="https://www.{{domain}}/Private-Terms-Jan-2019" target="_blank" class="hyper-link">Terms and Conditions</a>
                <a *ngIf="accountType === 'partner'" href="https://www.{{domain}}/partner-terms/" target="_blank" class="hyper-link">Terms and Conditions</a>
                and agree to be bound by the
                <span *ngIf="accountType === 'partner'">Partner Agreement.&nbsp;</span>
                <span *ngIf="accountType === 'client'">Client Trading Agreement.&nbsp;</span>
                <mat-checkbox class="check-box greengo" [checked]="agree" (change)="changeChecked()"></mat-checkbox>
              </li>
            </ol>
          </div>
          <div class="form-group">
            <button class="btn btn-block btn-lg btn-greengo" (click)="onSubmit()" npFocusOutClicked>
              Finish
            </button>
          </div>
        </div>
      </div>
    </ng-container>
  </form>
</div>
